import { messages } from 'helpers/validationMessages'
import * as yup from 'yup'

import { TFitterProfileResponse } from '../types'

export const serviceRegionSchema: yup.ObjectSchema<{
  address: string
  fiasId: string
}> = yup.object({
  address: yup.string().required(),
  fiasId: yup.string().required(),
})

export const editUserFormSchema = yup.object().shape({
  firstname: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  lastname: yup
    .string()
    .required(messages.required)
    .max(100, messages.maxLength(100))
    .test('notOnlySpaces', messages.required, value => value.trim() !== ''),
  middlename: yup.string().max(100, messages.maxLength(100)),
  email: yup.string().required(messages.required),
  productTypes: yup
    .array()
    .of(yup.string())
    .required(messages.required)
    .min(1, messages.required),
  serviceRegions: yup
    .array()
    .of(serviceRegionSchema)
    .required(messages.required)
    .min(1, messages.required),
})

export const editUserFormDefaultValues = (
  data: TFitterProfileResponse | undefined,
) => {
  const selectedProductTypes =
    data?.products.map(product => product.productType) ?? []

  const serviceRegions = data?.regions.map(region => ({
    address: region.name,
    fiasId: region.kladrId,
    kladrId: region.kladrId,
  }))

  return {
    firstname: data?.firstName || '',
    lastname: data?.lastName || '',
    middlename: data?.fatherName || '',
    email: data?.email || '',
    companyName: data?.name || '',
    serviceRegions: serviceRegions || [],
    productTypes: selectedProductTypes,
    locationAddress: data?.locationAddress,
  }
}

export const editUserFormDefaultValuesForReset = (
  data: TFitterProfileResponse | undefined,
) => {
  return {
    firstname: data?.firstName || '',
    lastname: data?.lastName || '',
    middlename: data?.fatherName || '',
    address: data?.locationAddress || '',
    personalAgree: true,
  }
}
